import { configEnv } from '@libraries/config';

const seoConfig = {
  title: 'SIMANTEP',
  description: 'Aplikasi WMS SIMANTEP',
  openGraph: {
    type: 'website',
    locale: 'id_ID',
    url: configEnv.baseUrl,
    siteName: 'perpack',
  },
  twitter: {
    handle: '@perpack',
    site: '@perpack',
    cardType: 'summary_large_image',
  },
};

export default seoConfig;
